import { render, staticRenderFns } from "./AttachActionsets.vue?vue&type=template&id=515c8558&scoped=true"
import script from "./AttachActionsets.vue?vue&type=script&lang=js"
export * from "./AttachActionsets.vue?vue&type=script&lang=js"
import style0 from "./AttachActionsets.vue?vue&type=style&index=0&id=515c8558&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515c8558",
  null
  
)

export default component.exports